import cx from 'classnames'
import React from 'react'

import { IconButton } from '../IconButton'
import { Close } from '../SVGs/Close'

export type Props = {
  id?: string
  closeButtonId?: string
  children: React.ReactNode
  onClose: () => void
  title: React.ReactNode
  contentClassName?: string
  className?: string
}

export const Modal = ({
  id,
  closeButtonId,
  children,
  onClose,
  title,
  className,
  contentClassName,
}: Props) => (
  <div
    id={id}
    role='presentation'
    className={cx(
      'fixed top-0 left-0 w-screen h-screen flex items-center justify-center',
      className,
    )}
  >
    <div
      className={cx(
        'modal-max-h mx-2 bg-white shadow-lg rounded-md flex flex-col',
        contentClassName,
      )}
    >
      <div className='py-4 px-6 border-0 border-b border-solid border-grey-lighter flex justify-between'>
        <div className='text-lg font-semibold'>{title}</div>
        <IconButton id={closeButtonId} onClick={onClose} type='button'>
          <Close className='w-5 h-5' />
        </IconButton>
      </div>
      <div className='py-4 px-6 overflow-auto flex-1'>{children}</div>
    </div>
  </div>
)
